import { ChildType, NodeVariableTypes } from "@common/types/tree-types";
import {
  BlueprintFolderNodeInterface,
  BlueprintVariableNodeInterface,
} from "../blueprint/blueprint-interfaces";

const createBlueprintVariableNode = (
  node: NodeVariableTypes,
): BlueprintVariableNodeInterface => {
  return {
    id: node.id,
    name: node.name,
    node_type: node.node_type,
    attributes: {
      data_acquisition_type: node.attributes?.data_acquisition_type,
      sample_interval_in_seconds: node.attributes?.sample_interval_in_seconds,
      node_class: node.attributes?.node_class,
      data_type: {
        type_node_id: node.attributes?.data_type?.type_node_id,
      },
      unit: node.attributes?.unit
        ? {
            code: node.attributes?.unit.code,
            display_name: node.attributes?.unit.display_name,
            description: node.attributes?.unit.description,
          }
        : null,
      data_type_as_string: node.attributes?.data_type_as_string,
      node_class_as_string: node.attributes?.node_class_as_string,
    },
  };
};

// TODO: fix any
const createBlueprintFolderNode = (
  node: any,
  deleteSourceType = true,
): BlueprintFolderNodeInterface => {
  const newNode = { ...node };
  delete newNode.selected;
  delete newNode.transferred;
  delete newNode.key;

  if (
    newNode.node_type === "FOLDER" &&
    "children" in newNode &&
    newNode.children.length > 0
  ) {
    if (deleteSourceType) {
      delete newNode.source_type;
    }
    delete newNode.total_number_of_nodes;
    newNode.children = newNode.children.map((child: ChildType) =>
      createBlueprintFolderNode(child),
    );
  } else if ("attributes" in newNode) {
    createBlueprintVariableNode(newNode);
  }
  return newNode;
};

export const createRootNodeForBlueprint = (
  root_node: ChildType | object,
): BlueprintFolderNodeInterface => {
  const blueprintRootNode: BlueprintFolderNodeInterface =
    createBlueprintFolderNode(root_node, false);
  return blueprintRootNode;
};
